import * as Styled from './styles'

export default function Text({ children }) {
  return <Styled.Text>{children}</Styled.Text>
}
